import { createFileRoute, redirect } from "@tanstack/react-router";

/** Lens is the home surface. Kept as a named entry point for deep links. */
export const Route = createFileRoute("/lens")({
  beforeLoad: () => { throw redirect({ to: "/" }); },
});
